import { HttpRequest } from "@angular/common/http";

export function serializeBodyAsString(request: HttpRequest<any>): string {
  let serialized = request.serializeBody();

  if (serialized instanceof ArrayBuffer) {
    return `[ArrayBuffer (Binary Data) with ${serialized.byteLength} bytes]`;
  }

  if (serialized instanceof FormData) {
    const entries: [string, string][] = [];
    for (const [k, v] of serialized.entries()) {
      if (typeof v === "string") {
        entries.push([k, v]);
      } else if (v instanceof File) {
        entries.push([k, `File: ${v.name}`]);
      }
    }
    return new URLSearchParams(entries).toString();
  }

  if (serialized instanceof Blob) {
    return `[Binary Large Object (Blob) with size: ${serialized.size} and type ${serialized.type}]`;
  }

  if (typeof request.body === 'object') {
    try {
      const bodyCopy = { ...request.body };

      // Tokens aren't normally included in requests bodies since they are handled via cookies,
      // but attempt to filter out any tokens.
      for (const key of Object.keys(bodyCopy)) {
        const normalizedKey = key.toLowerCase();
        if (normalizedKey.includes('token') || normalizedKey.includes('provisioner')) {
          bodyCopy[key] = '[REDACTED]';
        }
      }
      serialized = JSON.stringify(bodyCopy);
    } catch (e) {
      return 'Failed to serialize request body';
    }
  }

  if (serialized instanceof URLSearchParams) {
    return serialized.toString();
  }

  return serialized;
}
